import request from '@/axios/request';

//获得组织机构树数据
export function getOrganizationalManagementTree(data) {
  return request({
    //api.Hallowmas 引用url.js里面的数据
    url:'/api/organizational/getOrganizationalManagementTree',
    method: 'get',//请求方法
    params:{
      groupId:data.groupId, //传过去的参数
      accountId: data.accountId
    }
  })
}
//获得人员列表数据
export function getOrgUserList(dataParameter) {
  return request({
    url:'/api/orgUser/getOrgUserList',
    method:'get',
    params:dataParameter
  })
}
//保存人员数据
export function addOrgUser(dp) {
  return request({
    url:'/api/orgUser/addOrgUser',
    method:'post',
    data:dp
  })
}


//保存人员数据
export function editOrgUser(dp) {
  return request({
    url:'/api/orgUser/eidtOrgUser',
    method:'post',
    data:dp
  })
}
//保存人员数据
export function editOrgUserInfo(dp) {
  return request({
    url:'/api/orgUser/editOrgUserInfo',
    method:'post',
    data:dp
  })
}

export function delOrgUser(dp) {
  return request({
    url:'/api/orgUser/delOrgUser',
    method:'post',
    data:dp
  })
}
export function getOrgUserRoleList(dp) {
  return request({
    url:'/api/orgUser/getOrgUserRoleList?id='+ dp.id +'&orgId=' + dp.orgId,
    method:'get',
  })
}
export function eidtOrgUserRole(dp) {
  return request({
    url:'/api/orgUser/eidtOrgUserRole',
    method:'post',
    data:dp
  })
}
export function editOrgUserState(dp) {
  return request({
    url:'/api/orgUser/editOrgUserState',
    method:'post',
    data:dp
  })
}
export function updateSequence(dp) {
  return request({
    url:'/api/orgUser/updateSequence',
    method:'post',
    data:dp
  })
}






// WEBPACK FOOTER //
// ./src/api/peopleApi.js